module.exports = __webpack_public_path__ + "static/media/484.4d1060ad.webp";